import { ADJUSTMENT_LINE_TYPES } from '../../sales-order-lines/adjustment-line-types.js';
import { STOCKED_LINE_TYPES } from '../../sales-order-lines/stocked-line-types.js';
export const BOOK_SALES_ORDER_LINE_TYPE_IDS = new Set([
    ...STOCKED_LINE_TYPES,
    ...ADJUSTMENT_LINE_TYPES,
]);
//# sourceMappingURL=book-sales-order-line-type-ids.js.map